// extracted by mini-css-extract-plugin
module.exports = {"nextEpisodeBtn":"styles_nextEpisodeBtn__3vwSX","fillBtn":"styles_fillBtn__2hTa2"};